import { AfterViewInit, Directive, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

/**
 * Base class for scrollable components that emit an event when scrolled to the bottom. A scrollable element
 * with the template reference variable `#scrollContainer` is required in the component's template.
 * @template T - The type of the query object which will be emitted when scrolled to the bottom.
 * @extends {AfterViewInit}
 * @abstract
 */
@Directive()
export abstract class ScrollableBase<T> implements AfterViewInit {
  @Output() public scrolledToBottom: EventEmitter<T> = new EventEmitter<T>();
  @ViewChild('scrollContainer', { static: false })
  public scrollContainer!: ElementRef;

  protected query?: T;

  public ngAfterViewInit(): void {
    this.scrollContainer.nativeElement.addEventListener('scroll', () => {
      this.onScroll();
    });
  }

  public scrollFewElementsDown(): void {
    const element = this.scrollContainer.nativeElement;
    element.scrollTop = element.scrollTop + 100;
  }

  protected onScroll(): void {
    const element = this.scrollContainer.nativeElement;
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 20) {
      if (this.query) {
        this.scrolledToBottom.emit(this.query);
      } else {
        this.scrolledToBottom.emit();
      }
    }
  }
}
